import { render, staticRenderFns } from "./AdminContentArea.vue?vue&type=template&id=ef270326"
import script from "./AdminContentArea.vue?vue&type=script&lang=js"
export * from "./AdminContentArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports